import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { HazardStripe } from './HazardStripe';
export function Hero() {
  return <header className="bg-ink text-center" data-id="element-102" data-mp="ei1w7odj86z0">
      <HazardStripe className="h-1.5" data-id="element-103" data-mp="9k0h1ej88rst" />
      <div className="blueprint-grid px-3 pb-4 pt-3 sm:px-6 sm:pb-5 sm:pt-4" data-id="element-104" data-mp="9l375k8q6q7o">
        <h1 className="font-display text-[0.78rem] font-bold uppercase leading-tight text-steel sm:text-[1rem]" data-id="element-105" data-mp="4n1ov1j4iux9">
          THE COMPLETE <span className="text-hazard" data-id="element-106" data-mp="127ed7af3pjbv">CONSTRUCTION SITE MANAGEMENT</span> SYSTEM
        </h1>
        <p className="mt-1 font-display text-[1.5rem] font-extrabold uppercase leading-[1.05] text-white sm:text-[2.3rem]" data-id="element-107" data-mp="x8b9btauxj5h">
          STOP MANAGING YOUR JOBSITE FROM SCATTERED NOTES.{' '}
          <span className="text-hazard" data-id="element-108" data-mp="nbygexn4z9bs">START RUNNING IT WITH A SYSTEM.</span>
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-109" data-mp="3d33fx1m3uzmc">
          Organize daily construction operations, coordinate crews, track materials, monitor project
          progress, manage site issues, and create professional reports—all in one ready-to-use
          construction site management system.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[280px] sm:max-w-[370px]" data-id="element-110" data-mp="39authk0ozz0e" />

        <div className="mx-auto mt-2 max-w-md" data-id="element-111" data-mp="3e9fqzbok84l5">
          <CTAButton label="🚀 YES! I WANT MY CONSTRUCTION SITE SYSTEM NOW" data-id="element-112" data-mp="3e84m18jdoqsg" />
          <p className="mt-2 text-[0.68rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-113" data-mp="30hrev8eb9g46">
            🛡️ 7-Day Money-Back Guarantee — Zero Risk
          </p>
        </div>
      </div>
      <HazardStripe data-id="element-114" data-mp="2qkmthasahoof" />
    </header>;
}